
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABmUExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/2qb/2mb/5y9/+bv/////12T/9rm/8DV/4Or/3ej /83e/9nm/83d/3aj/wAAAF8RwTAAAAASdFJOUwBAj9/PnyAQkI/PQM/PjxDfP5LbpTEAAAABYktH RACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5wwEAzkjI6K5XQAAAJRJREFUKM/N 0s0SgjAMRtHPQFsQFalo6w/q+z+lKaDTMo0bN96ZLpoz2QXgVlTYpFJpTJnKZqrNaKXNtg5aWaEa 0FasgZKRsEn+hz76FIjleHLOR4MP+iBcn8OJBHS/4/lylZHfv+NteOOd3+AT9I+k54yL04rbYiej QiMjn6e4Snx97bfTRJvdJTPfvFaL7T11Yf4CnfE2nO4HZkYAAAAldEVYdGRhdGU6Y3JlYXRlADIw MjMtMTItMDRUMDI6MzI6MTIrMDA6MDBWeKhCAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTEyLTA0 VDAyOjMyOjEyKzAwOjAwJyUQ/gAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMy0xMi0wNFQwMzo1 NzozNSswMDowMCS40FAAAAAASUVORK5CYII="}})])
          )
        }
      }
    